/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {MonkeysGoldGameModuleConfig} from "../MonkeysGoldGameModuleConfig";
import {MonkeysGoldBitmapText} from "./MonkeysGoldBitmapText";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {MonkeysGoldColossalSpine} from "./MonkeysGoldColossalSpine";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../MonkeysGoldGameConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../MonkeysGoldSoundConfig";

export interface IMonkeysGoldSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
}

export class MonkeysGoldReelSymbol extends StateReelSymbol {

    private _bigSymbolMultiplier:number;
    private _bigSymbolFinalMultiplier:number;
    private _numberAdded:boolean = false;
    private _multiplierText:MonkeysGoldBitmapText;
    private _multiplierTextNoWin:MonkeysGoldBitmapText;
    private _currentMultiplier:number;
    private _turnAnimationContainer:PIXI.Container;
    private _multiplierContainer:PIXI.Container;
    private _turnAnimation:MonkeysGoldColossalSpine;
    private _originalSymName:string;
    private _bottomLeftPosition:number[];
    private _symbols:string[] = ["L5", "L4", "L3", "L2", "L1", "M5", "M4", "M3", "M2", "M1", "M1_2", "M1_3", "M1_4", "M1_5", "M1_6", "M1_7"];

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
        this._originalSymName = symName.slice(0, 2);
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        //Make sure colossals turn animation with multipliers are on top in normal state
        if((this.symName.indexOf("colossalx2") > -1) || (this.symName.indexOf("colossalx3") > -1)) {
            if(newState.state.keyword == "normal") {
                if(!this._turnAnimationContainer) {
                    this._turnAnimationContainer = new PIXI.Container();
                }
                this.addChild(this._turnAnimationContainer);
            }
            //Make sure big symbol multiplier text has normal state on spin out
            if(newState.state.keyword == "spin" && (this._currentState!.keyword == "noWin" || this._currentState!.keyword == "win")) {
                this.getMultiplierTextSpinOutTint();
            }
            if(!this._multiplierContainer) {
                this._multiplierContainer = new PIXI.Container();
            }
            this.addChild(this._multiplierContainer);
        }

        if(this._bigSymbolMultiplier && this._numberAdded == false) {
            this._numberAdded = true;
            if(!this._multiplierContainer) {
                this._multiplierContainer = new PIXI.Container();
            }
            if(!this._turnAnimationContainer) {
                this._turnAnimationContainer = new PIXI.Container();
            }
            this.addChild(this._turnAnimationContainer);
            this.addChild(this._multiplierContainer);
            if(this.symName.indexOf("colossalx2") > -1) {
                //Get 2x2 animation from controller
                this._turnAnimation = MonkeysGoldGameModuleConfig.monkeysGoldColossalUpgradeAnimationController.get2x2UpgradeAnimation();
                this._multiplierText = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get2x2MultiplierText();
                this._multiplierTextNoWin = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get2x2MultiplierText();
            } else {
                //Get 3x3 animation from controller
                this._turnAnimation = MonkeysGoldGameModuleConfig.monkeysGoldColossalUpgradeAnimationController.get3x3UpgradeAnimation();
                this._multiplierText = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get3x3MultiplierText();
                this._multiplierTextNoWin = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get3x3MultiplierText();
                this._multiplierText.scale.set(1.6, 1.6);
                this._multiplierTextNoWin.scale.set(1.6, 1.6);
            }
            this._turnAnimationContainer.addChild(this._turnAnimation);
            this._multiplierText.text = "x" + this._bigSymbolMultiplier.toString();
            this._currentMultiplier = this._bigSymbolMultiplier;
            this._multiplierText.visible = false;
            this._multiplierContainer.addChild(this._multiplierText);
            this._multiplierTextNoWin.text = "x" + this._bigSymbolMultiplier.toString();
            this._multiplierTextNoWin.tint = 0x555555;
            this._multiplierTextNoWin.visible = false;
            this._multiplierContainer.addChild(this._multiplierTextNoWin);
        }
        if(this.symName.indexOf("colossalx2") > -1) {
            stateAnimation.anchor.set(0.75, 0.75);
        } else if(this.symName.indexOf("colossalx3") > -1) {
            stateAnimation.anchor.set(0.833, 0.833);
        }
    }

    public playMultiplierTextLandAnimation():void {
        const addToXPos:number = this._multiplierText.parent.parent.parent.position.x;
        const addToYPos:number = this._multiplierText.parent.parent.position.y + this._multiplierText.parent.parent.parent.parent.position.y;
        const targetXPos:number = this._multiplierText.x += addToXPos;
        const targetYPos:number = this._multiplierText.y += addToYPos;
        const currentScaleX:number = this._multiplierText.scale.x;
        const currentScaleY:number = this._multiplierText.scale.y;
        const landTL:TimelineLite = new TimelineLite();
        landTL.add(() => StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.LOGO.name).addChild(this._multiplierText), "+=0.2");
        landTL.add(() => this._multiplierText.x = targetXPos);
        landTL.add(() => this._multiplierText.y = targetYPos);
        landTL.add(() => this._multiplierText.alpha = 0);
        landTL.add(() => this._multiplierText.scale.set(currentScaleX * 7, currentScaleY * 7));
        landTL.add(() => this._multiplierText.visible = true);
        landTL.add([
            () => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.BIG_SYMBOL_MULTIPLIER)}),
            new TweenLite(this._multiplierText, 0.3, {alpha : 1, ease : Linear.easeNone}),
            new TweenLite(this._multiplierText.scale, 0.3, {
                x : currentScaleX,
                y : currentScaleY,
                ease : Linear.easeNone
            })
        ]);
        landTL.add([
            TweenLite.to(StageManager.stage, 0.4, {
                y : "-=" + 5,
                x : "+=" + 2,
                ease : "shakeBounce"
            })
        ]);
        landTL.add([
            () => this._multiplierContainer.addChildAt(this._multiplierText, 0),
            () => this._multiplierText.position.x = (targetXPos - addToXPos),
            () => this._multiplierText.position.y = (targetYPos - addToYPos)
        ]);
    }

    //Only used on restore
    public initMultiplierText(symbolSize:number):void {
        this._numberAdded = true;
        if(symbolSize == 2) {
            //Get 2x2 animation from controller
            this._multiplierText = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get2x2MultiplierText();
            this._multiplierTextNoWin = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get2x2MultiplierText();
        } else {
            //Get 3x3 animation from controller
            this._multiplierText = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get3x3MultiplierText();
            this._multiplierTextNoWin = MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController.get3x3MultiplierText();
        }
        this._multiplierText.text = "x" + this._bigSymbolFinalMultiplier.toString();
        this._currentMultiplier = this._bigSymbolFinalMultiplier;
        this._multiplierText.visible = true;
        if(!this._multiplierContainer) {
            this._multiplierContainer = new PIXI.Container();
        }
        this._multiplierContainer.addChild(this._multiplierText);
        this._multiplierTextNoWin.tint = 0x555555;
        this._multiplierTextNoWin.text = "x" + this._bigSymbolFinalMultiplier.toString();
        this._multiplierTextNoWin.visible = false;
        this._multiplierContainer.addChild(this._multiplierTextNoWin);
    }

    //Only used on restore
    public initUpgradeAnimation(symbolSize:number):void {
        if(!this._turnAnimationContainer) {
            this._turnAnimationContainer = new PIXI.Container();
        }
        this.addChild(this._turnAnimationContainer);
        this.addChild(this._multiplierContainer);
        if(symbolSize == 2) {
            //Get 2x2 animation from controller
            this._turnAnimation = MonkeysGoldGameModuleConfig.monkeysGoldColossalUpgradeAnimationController.get2x2UpgradeAnimation();
        } else {
            //Get 3x3 animation from controller
            this._turnAnimation = MonkeysGoldGameModuleConfig.monkeysGoldColossalUpgradeAnimationController.get3x3UpgradeAnimation();
        }
        this._turnAnimationContainer.addChild(this._turnAnimation);
    }

    public getMultiplierTextSpinOutTint():void {
        this._multiplierText.alpha = 1;
        this._multiplierText.visible = true;
        this._multiplierTextNoWin.visible = false;
        this._multiplierTextNoWin.alpha = 1;
    }

    public getMultiplierTextWinTint():void {
        if(this._multiplierTextNoWin.visible == false) {
            return;
        }
        const fadeInTL:TimelineLite = new TimelineLite();
        fadeInTL.add(() => this._multiplierText.alpha = 0);
        fadeInTL.add(() => this._multiplierText.visible = true);
        fadeInTL.add(() => this._multiplierContainer.addChild(this._multiplierText));
        fadeInTL.add([
            new TweenLite(this._multiplierText, 0.2, {alpha : 1, ease : Linear.easeNone}),
            new TimelineLite({delay : 0.1}).add(new TweenLite(this._multiplierTextNoWin, 0.1, {
                alpha : 0,
                ease : Linear.easeNone
            }))
        ]);
        fadeInTL.add(() => this._multiplierTextNoWin.visible = false);
        fadeInTL.add(() => this._multiplierTextNoWin.alpha = 1);
    }

    public getMultiplierTextNoWinTint():void {
        if(this._multiplierText.visible == false) {
            return;
        }
        const fadeOutTL:TimelineLite = new TimelineLite();
        fadeOutTL.add(() => this._multiplierTextNoWin.alpha = 0);
        fadeOutTL.add(() => this._multiplierTextNoWin.visible = true);
        fadeOutTL.add(() => this._multiplierContainer.addChild(this._multiplierTextNoWin));
        fadeOutTL.add([
            new TweenLite(this._multiplierTextNoWin, 0.2, {alpha : 1, ease : Linear.easeNone}),
            new TimelineLite({delay : 0.1}).add(new TweenLite(this._multiplierText, 0.1, {
                alpha : 0,
                ease : Linear.easeNone
            }))
        ]);
        fadeOutTL.add(() => this._multiplierText.visible = false);
        fadeOutTL.add(() => this._multiplierText.alpha = 1);
    }

    public playColossalUpgradeAnimation(size:string, targetSym:string = ""):TimelineLite {
        const turnAnimationTL:TimelineLite = new TimelineLite();
        const numberOfUpgrades:number = this._symbols.indexOf(targetSym) - this._symbols.indexOf(this._originalSymName);
        turnAnimationTL.add(() => this._turnAnimation.updateTransform());
        turnAnimationTL.add(() => this._turnAnimation.visible = true);
        turnAnimationTL.add(() => this._turnAnimation.skeleton.setSkin(null));
        const numberOfMultiplierUpgrades:number = (this._bigSymbolFinalMultiplier - this._currentMultiplier) / this._bigSymbolMultiplier;
        let skipMultiplierUpgrades:number = 0;
        if((numberOfMultiplierUpgrades > 0) && (numberOfUpgrades > numberOfMultiplierUpgrades)) {
            skipMultiplierUpgrades = numberOfUpgrades - numberOfMultiplierUpgrades;
        }
        for(let i:number = 0; i < numberOfUpgrades; i++) {
            turnAnimationTL.add(() => this._turnAnimation.skeleton.setSkinByName(this.getSkinName(this._originalSymName)), "+=" + (0.4 * i));
            turnAnimationTL.add(() => this._turnAnimation.skeleton.setSlotsToSetupPose());
            turnAnimationTL.add(() => TweenLite.to(this._multiplierText, 0.1, {alpha : 0}));
            turnAnimationTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.BIG_SYMBOL_TURNING)}));
            turnAnimationTL.add(new SpineTween(this._turnAnimation, 0, "All symbols turn" + size + "x" + size, 0));
            turnAnimationTL.add(() => {
                if(numberOfMultiplierUpgrades > 0 && (i >= skipMultiplierUpgrades)) {
                    this._currentMultiplier = this._bigSymbolMultiplier * ((i - skipMultiplierUpgrades) + 2);
                    this._multiplierText.text = "x" + this._currentMultiplier.toString();
                    this._multiplierTextNoWin.text = "x" + this._currentMultiplier.toString();
                } else {
                    this._multiplierTextNoWin.text = "x" + this._bigSymbolFinalMultiplier.toString();
                }
            });
            turnAnimationTL.add(() => TweenLite.to(this._multiplierText, 0.1, {alpha : 1}));
        }
        turnAnimationTL.add(() => this._originalSymName = targetSym);
        return turnAnimationTL;
    }

    public resetAnimations():void {
        if(this._multiplierText) {
            this._multiplierContainer.removeChild(this._multiplierText);
            this._multiplierText.visible = false;
            this._multiplierText.inUse = false;
            this._multiplierText.tint = 0xffffff;
            this._multiplierText.scale.set(1, 1);
            this._multiplierContainer.removeChild(this._multiplierTextNoWin);
            this._multiplierTextNoWin.visible = false;
            this._multiplierTextNoWin.inUse = false;
            this._multiplierTextNoWin.tint = 0xffffff;
            this._multiplierTextNoWin.scale.set(1, 1);
            this._turnAnimationContainer.removeChild(this._turnAnimation);
            this._turnAnimation.visible = false;
            this._turnAnimation.inUse = false;
        }
    }

    private getSkinName(targetSym:string):string {
        switch(targetSym) {
            case "M1_7":
                return "m1_to_m1";
            case "M1_6":
                return "m1_to_m1";
            case "M1_5":
                return "m1_to_m1";
            case "M1_4":
                return "m1_to_m1";
            case "M1_3":
                return "m1_to_m1";
            case "M1_2":
                return "m1_to_m1";
            case "M1" :
                this._originalSymName = "M1";
                return "m1_to_m1";
            case "M2" :
                this._originalSymName = "M1";
                return "m2_to_m1";
            case "M3" :
                this._originalSymName = "M2";
                return "m3_to_m2";
            case "M4" :
                this._originalSymName = "M3";
                return "m4_to_m3";
            case "M5" :
                this._originalSymName = "M4";
                return "m5_to_m4";
            case "L1" :
                this._originalSymName = "M5";
                return "l1_to_m5";
            case "L2" :
                this._originalSymName = "L1";
                return "l2_to_l1";
            case "L3" :
                this._originalSymName = "L2";
                return "l3_to_l2";
            case "L4" :
                this._originalSymName = "L3";
                return "l4_to_l3";
            case "L5" :
                this._originalSymName = "L4";
                return "l5_to_l4";
            default :
                return "";
        }
    }

    set bigSymbolMultiplier(value:number) {
        this._bigSymbolMultiplier = value;
    }

    get bigSymbolMultiplier():number {
        return this._bigSymbolMultiplier;
    }

    set bigSymbolFinalMultiplier(value:number) {
        this._bigSymbolFinalMultiplier = value;
    }

    get originalSymName():string {
        return this._originalSymName;
    }

    get bottomLeftPosition():number[] {
        return this._bottomLeftPosition;
    }

    set bottomLeftPosition(value:number[]) {
        this._bottomLeftPosition = value;
    }

    get multiplierText():MonkeysGoldBitmapText {
        return this._multiplierText;
    }
}